<template>
  <div class="my-4 row">
    <h3>Productos similares</h3>
    <div class="my-4 col-sm-10 col-md-12">
      <div class="row">
        <div
          class="col-sm-12 col-md-4"
          v-for="producto in similar.slice(0, 3)"
          v-bind:key="producto.id"
        >
          <router-link
            target="_blank"
            style="color: #000"
            :to="{
              name: 'producto',
              params: { id: producto.id },
            }"
          >
            <div>
              <h5>{{ producto.name }}</h5>
              <img loading="lazy" height="200px" :src="producto.small_picture" alt="product"/>
              <p class="my-3">
                {{ producto.prices[0].description }}
                <span class="font-weight-bold"
                  >${{ producto.prices[0].price }}</span
                >
              </p>
            </div>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SimilarProduct",
  props: ["similarProducts"],

  data() {
    return {
      similar: "",
    };
  },
  created() {
    this.similar = this.similarProducts;
  },
};
</script>

<style>
</style>